<template lang="pug">
  .mr-newsletter-subscription
    p.success-alert(v-if="justSubscribed" role="alert") You have been successfully subscribed!
    p(v-if="isSubscribed") You're on the list!
    form(v-if="!isSubscribed && !justSubscribed" name="newsletterForm" ref="newsletterForm" @submit.prevent="onSubmit")
      input#newsletter-signup(name="emailInput" @keydown="verifyEmail" type='email' placeholder='Enter your email' v-model="email" @input="$v.email.$touch()" required)
      button.button(v-if='!isSubscribed' type="submit" aria-label="join") {{buttonText || 'JOIN'}}

      span.mail-note(v-if="mailCheckedEmail" @click="setEmail") Did you mean 
        span {{ mailCheckedEmail }}
        span  ?

    .captcha(v-if="showCaptcha")
      Captcha(@captcha-response="setCaptchaResponse")

    p(v-if="errorMessage") {{errorMessage}}

</template>

<script>
import { newsletterSignUp, getSignInData } from '../../services/vueCustomerSvc';
import Captcha from '../captcha';
const { required, email } = require('vuelidate/lib/validators');

let Mailcheck;

export default {
  name: 'MrNewsletterSubscription',

  components: {
    Captcha,
  },

  props: {
    buttonText: {
      type: String,
      default: '',
    },
    source: {
      type: String,
      default: '',
    },
  },

  data: () => ({
    isSubscribed: false,
    justSubscribed: false,
    mailCheckedEmail: false,
    showCaptcha: false,
    email: '',
    captchaResponse: false,
    errorMessage: undefined,
  }),

  validations: {
    email: {
      required,
      email,
    },
  },

  async mounted() {
    // Client-only imports for SSR
    const {default: sentry} = await import ('../../addSentry.js');
    Mailcheck = require('mailcheck');

    getSignInData()
      .then(results => {
        if (results.data.email) {
          this.isSubscribed = true;
        }
      })
      .catch(err => {
        // send to sentry
        sentry.withScope(scope => {
          scope.setTag('vueComponent', 'mrNewsletterSubscription');
          sentry.captureException(err);
        });
      });
  },
  methods: {
    setCaptchaResponse(response) {
      this.captchaResponse = response;
      this.showCaptcha = false;
      this.errorMessage = undefined;
    },
    onSubmit() {
      if (this.$v.$invalid) {
        return;
      }
      newsletterSignUp({
        email: this.email,
        source: this.source,
        captchaResponse: this.captchaResponse,
      })
        .then(() => {
          this.justSubscribed = true;
          this.showCaptcha = false;
          this.errorMessage = undefined;
        })
        .catch(err => {
          const error = err.response;
          if (error && error.data && error.data.code == 'CAPTCHA') {
            this.showCaptcha = true;
          }
          if (error && error.data && error.data.errors) {
            this.errorMessage = error.data.errors.email;
          } else {
            this.errorMessage = error.data.message;
          }
        });
    },
    verifyEmail() {
      if (!Mailcheck) {
        console.error('Mailcheck has not been initialized on MrNewsLetterSubscription');
        return;
      }

      Mailcheck.run({
        email: this.email,
        suggested: suggestion => {
          if (suggestion.full == email) {
            return (this.mailCheckedEmail = false);
          }
          this.mailCheckedEmail = suggestion.full;
        },
        empty: () => {
          this.mailCheckedEmail = false;
        },
      });
    },
    setEmail() {
      this.email = this.mailCheckedEmail;
      this.mailCheckedEmail = false;
    },
  },
};
</script>

<style scoped lang="stylus">
.mail-note
  margin-bottom 0.75em

  span:first-of-type
    text-decoration underline
    cursor pointer
</style>
